import { LEVELS, TYPES } from '../Const';

export const InsuranceMapping = {
  totalAssets: 'bsa53',
  currentAssets: 'bsa1',
  cashAndCashEquivalents: 'bsa2',
  cash: 'bsa3',
  cashEquivalents: 'bsa4',
  shorttermInvestments: 'bsa5',
  shorttermInvestmentsChild: 'bsa6',
  provisionForDiminution: 'bsa7',
  shorttermInvestmentsHeldtomaturityInvestment: 'bsb108',
  heldtomaturityInvestment: 'bsa165',
  accountsReceivables: 'bsa8',
  tradeAccountsReceivables: 'bsa9',
  receivableFromInsuranceContract: 'bsi198',
  otherReceivablesFromCustomers: 'bsi199',
  prepaymentsToSuppliers: 'bsa10',
  intercompanyReceivables: 'bsa11',
  constructionContractInProgressReceivables: 'bsa12',
  shorttermLoansReceivables: 'bsa159',
  advancedPayment: 'bsi139',
  receivableFromTradingStocks: 'bsi140',
  otherReceivables: 'bsa13',
  provisionForDoubfulDebts: 'bsa14',
  inventoriesNet: 'bsa15',
  inventories: 'bsa16',
  provisionForDeclineInInventories: 'bsa17',
  otherCurrentAssets: 'bsa18',
  otherCurrentAssetsChild: 'bsa22',
  shorttermPrepayments: 'bsa19',
  undistributedCommisionExpenses: 'bsi190',
  otherShorttermPrepayments: 'bsi191',
  shortageOfCurrentAssetsWaitingForSolution: 'bsi141',
  vatToBeClaimed: 'bsa20',
  otherTaxesReceivable: 'bsa21',
  marginDeposits: 'bsi142',
  governmentBondsPurchasedForResale: 'bsa160',
  reinsuranceAssets: 'bsi192',
  provisionForPremiumOutwardReinsurance: 'bsi193',
  provisionForClaimFormOutwardReinsurance: 'bsi194',
  loansAndAdvancesToCustomersOne: 'bsi143',
  loansAndAdvancesToCustomers: 'bsi144',
  provisionForCreditLoss: 'bsi145',
  longtermAsstes: 'bsa23',
  longTermTradeReceivables: 'bsa24',
  longTermTradeReceivablesChild: 'bsa25',
  longtermPrepaymentsToSuppliers: 'bsa161',
  paidinCapitalInWhollyownedSubsidiaries: 'bss134',
  longtermIntercompanyReceivables: 'bsa26',
  longtermLoansReceivables: 'bsa162',
  otherLongtermReceivables: 'bsa27',
  otherLongtermReceivablesChild: 'bsi196',
  insuranceDeposits: 'bsi195',
  provisionForDoubfulLongtermReceivables: 'bsa28',
  fixedAssets: 'bsa29',
  tangibleFixedAssets: 'bsa30',
  tangibleFixedAssetsCost: 'bsa31',
  tangibleFixedAssetsAccumulatedDepreciation: 'bsa32',
  financeLeaseAssets: 'bsa33',
  financeLeaseAssetsCost: 'bsa34',
  financeLeaseAssetsAccumulatedDepreciation: 'bsa35',
  intagibleFixedAssets: 'bsa36',
  intagibleFixedAssetsCost: 'bsa37',
  intagibleFixedAssetsAccumulatedDepreciation: 'bsa38',
  constructionInProgressBefore: 'bsa39',
  investmentProperties: 'bsa40',
  investmentPropertiesCost: 'bsa41',
  investmentPropertiesAccumulatedDepreciation: 'bsa42',
  longtermIncompleteAssets: 'bsa163',
  longtermCostOfWorkInProgress: 'bsa164',
  constructionInProgress: 'bsa188',
  longtermInvestments: 'bsa43',
  investmentInSubsidiaries: 'bsa44',
  investementInAssociates: 'bsa45',
  otherLongtermInvestements: 'bsa46',
  provisionForLongtermInvestments: 'bsa47',
  goodWillBefore: 'bsa48',
  otherLongtermAssets: 'bsa49',
  otherLongtermAssetsChild: 'bsa52',
  longtermPrepayments: 'bsa50',
  deferredIncomeTaxAssests: 'bsa51',
  longtermDeposit: 'bsi146',
  longtermEquimentMaterialAndSpare: 'bsa166',
  goodWill: 'bsa209',
  liabilities: 'bsa54',
  currentLiabilities: 'bsa55',
  shorttermLoans: 'bsa56',
  tradeAccountsPayable: 'bsa57',
  payablesFromInsuranceContract: 'bsi200',
  payablesToSuppliers: 'bsi201',
  advancesFromCustomers: 'bsa58',
  taxesAndOtherPayableToStateBudget: 'bsa59',
  payableToEmployees: 'bsa60',
  accruedExpenses: 'bsa61',
  intercompanyPayables: 'bsa62',
  constructionContractInProgressPayables: 'bsa63',
  shorttermUnrealizedRevenue: 'bsa167',
  unearnedCommissionIncome: 'bsi197',
  otherPayables: 'bsa64',
  provisionForShorttermLiabilities: 'bsa65',
  bonusAndWelfareFunds: 'bsa66',
  priceStablizationFund: 'bsa168',
  governmentBondsPurchasedForResales: 'bsa169',
  insuranceReserve: 'bsi202',
  unearnedPremiumReserve: 'bsi203',
  mathematicalReserve: 'bsi204',
  claimReserve: 'bsi205',
  catastropheReserve: 'bsi206',
  dividendReserve: 'bsi207',
  equalizationReserve: 'bsi208',
  amountDueToCustomers: 'bsi147',
  depositFormCommercialBanks: 'bsi148',
  depositFromCustomers: 'bsi149',
  longtermLiabilites: 'bsa67',
  longtermTradePayables: 'bsa68',
  longtermAdvancesFromCustomers: 'bsa170',
  longtermAccruedExpenses: 'bsa171',
  intracompanyPayablesForOperatingCapital: 'bsa172',
  longtermIntercompanyPayables: 'bsa69',
  otherLongtermPayables: 'bsa70',
  longtermLoans: 'bsa71',
  convertibleBonds: 'bsa173',
  preferredShares: 'bsa174',
  longtermDepositMortage: 'bsi150',
  deferredIncomeTaxesLiabilities: 'bsa72',
  provisionForSeveranceAllowances: 'bsa73',
  provisionForLongtermLiabilites: 'bsa74',
  deferredRevenue: 'bsa76',
  technologyscienceDevelopmentFund: 'bsa77',
  reservesBefore: 'bsa75',
  unearnedPremiumReserveBefore: 'bsi151',
  technicalReserveBefore: 'bsi152',
  claimReserveBefore: 'bsi153',
  catastropheReserveBefore: 'bsi154',
  dividendReseveBefore: 'bsi155',
  equalizatinReserveBefore: 'bsi156',
  ownersEquity: 'bsa78',
  capitalAndReserves: 'bsa79',
  paidinCapital: 'bsa80',
  paidinCapitalPreferredShares: 'bsb120',
  commonShares: 'bsa175',
  capitalAndReservesPreferredShares: 'bsb120',
  capitalSurplus: 'bsa81',
  ownersOtherCapital: 'bsa82',
  treasuryShares: 'bsa83',
  differencesUponAssetsRevaluation: 'bsa84',
  foreignExchangeDifferences: 'bsa85',
  investmentAndDevelopmentFunds: 'bsa86',
  financialReserveFunds: 'bsa87',
  statutoryReserve: 'bsa88',
  otherFunds: 'bsa89',
  undistributedEarnings: 'bsa90',
  beginningAccumulatedUndistritbutedEarning: 'bsa177',
  currentPeriodUndistributedEarnings: 'bsa178',
  enterpriseArragementFund: 'bsa91',
  minorityInterest: 'bsa210',
  budgetSourcesAndOtherFunds: 'bsa92',
  budgetSourcesAndOtherFundsChild: 'bsa94',
  bonusAndWelfareFundsBefore: 'bsa93',
  fundsUsedForFixedAssetAcquisitions: 'bsa211',
  minorityInterestBefore: 'bsa95',
  totalResources: 'bsa96',
};

export const BSInsuranceRows = [
  {
    id: 'chart',
    type: TYPES.CHART,
    level: LEVELS.PARENT,
  },
].concat(
  Object.keys(InsuranceMapping).map(key => {
    const mappingValue = InsuranceMapping[key];
    const defaultItem = {
      id: mappingValue,
      i18nKey: `BalanceSheetInsurance.${key}`,
      level: LEVELS.PARENT,
    };

    if (
      [
        InsuranceMapping.totalAssets,
        InsuranceMapping.currentAssets,
        InsuranceMapping.loansAndAdvancesToCustomersOne,
        InsuranceMapping.loansAndAdvancesToCustomers,
        InsuranceMapping.provisionForCreditLoss,
        InsuranceMapping.longtermAsstes,
        InsuranceMapping.goodWillBefore,
        InsuranceMapping.liabilities,
        InsuranceMapping.ownersEquity,
        InsuranceMapping.minorityInterestBefore,
        InsuranceMapping.totalResources,
      ].includes(mappingValue)
    ) {
      return defaultItem;
    }

    if (mappingValue === InsuranceMapping.cashAndCashEquivalents) {
      return {
        ...defaultItem,
        children: [InsuranceMapping.cash, InsuranceMapping.cashEquivalents],
      };
    }

    if (InsuranceMapping.shorttermInvestments === mappingValue) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.shorttermInvestmentsChild,
          InsuranceMapping.provisionForDiminution,
          InsuranceMapping.shorttermInvestmentsHeldtomaturityInvestment,
        ],
      };
    }

    if (InsuranceMapping.accountsReceivables === mappingValue) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.tradeAccountsReceivables,
          InsuranceMapping.prepaymentsToSuppliers,
          InsuranceMapping.intercompanyReceivables,
          InsuranceMapping.constructionContractInProgressReceivables,
          InsuranceMapping.shorttermLoansReceivables,
          InsuranceMapping.advancedPayment,
          InsuranceMapping.receivableFromTradingStocks,
          InsuranceMapping.otherReceivables,
          InsuranceMapping.provisionForDoubfulDebts,
        ],
      };
    }

    if (InsuranceMapping.tradeAccountsReceivables === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          InsuranceMapping.receivableFromInsuranceContract,
          InsuranceMapping.otherReceivablesFromCustomers,
        ],
      };
    }

    if (
      [
        InsuranceMapping.receivableFromInsuranceContract,
        InsuranceMapping.otherReceivablesFromCustomers,
      ].includes(mappingValue)
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    if (mappingValue === InsuranceMapping.inventoriesNet) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.inventories,
          InsuranceMapping.provisionForDeclineInInventories,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.otherCurrentAssets) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.shorttermPrepayments,
          InsuranceMapping.undistributedCommisionExpenses,
          InsuranceMapping.otherShorttermPrepayments,
          InsuranceMapping.shortageOfCurrentAssetsWaitingForSolution,
          InsuranceMapping.vatToBeClaimed,
          InsuranceMapping.otherTaxesReceivable,
          InsuranceMapping.marginDeposits,
          InsuranceMapping.governmentBondsPurchasedForResale,
          InsuranceMapping.otherCurrentAssetsChild,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.reinsuranceAssets) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.provisionForPremiumOutwardReinsurance,
          InsuranceMapping.provisionForClaimFormOutwardReinsurance,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.longTermTradeReceivables) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.longTermTradeReceivablesChild,
          InsuranceMapping.longtermPrepaymentsToSuppliers,
          InsuranceMapping.paidinCapitalInWhollyownedSubsidiaries,
          InsuranceMapping.longtermIntercompanyReceivables,
          InsuranceMapping.longtermLoansReceivables,
          InsuranceMapping.otherLongtermReceivables,
          InsuranceMapping.provisionForDoubfulLongtermReceivables,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.otherLongtermReceivables) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          InsuranceMapping.insuranceDeposits,
          InsuranceMapping.otherLongtermReceivablesChild,
        ],
      };
    }

    if (
      [
        InsuranceMapping.insuranceDeposits,
        InsuranceMapping.otherLongtermReceivablesChild,
      ].includes(mappingValue)
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    if (mappingValue === InsuranceMapping.fixedAssets) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.tangibleFixedAssets,
          InsuranceMapping.financeLeaseAssets,
          InsuranceMapping.intagibleFixedAssets,
          InsuranceMapping.constructionInProgressBefore,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.tangibleFixedAssets) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          InsuranceMapping.tangibleFixedAssetsCost,
          InsuranceMapping.tangibleFixedAssetsAccumulatedDepreciation,
        ],
      };
    }

    if (
      [
        InsuranceMapping.tangibleFixedAssetsCost,
        InsuranceMapping.tangibleFixedAssetsAccumulatedDepreciation,
      ].includes(mappingValue)
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    if (mappingValue === InsuranceMapping.financeLeaseAssets) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          InsuranceMapping.financeLeaseAssetsCost,
          InsuranceMapping.financeLeaseAssetsAccumulatedDepreciation,
        ],
      };
    }

    if (
      [
        InsuranceMapping.financeLeaseAssetsCost,
        InsuranceMapping.financeLeaseAssetsAccumulatedDepreciation,
      ].includes(mappingValue)
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    if (mappingValue === InsuranceMapping.intagibleFixedAssets) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          InsuranceMapping.intagibleFixedAssetsCost,
          InsuranceMapping.intagibleFixedAssetsAccumulatedDepreciation,
        ],
      };
    }

    if (
      [
        InsuranceMapping.intagibleFixedAssetsCost,
        InsuranceMapping.intagibleFixedAssetsAccumulatedDepreciation,
      ].includes(mappingValue)
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    if (mappingValue === InsuranceMapping.investmentProperties) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.investmentPropertiesCost,
          InsuranceMapping.investmentPropertiesAccumulatedDepreciation,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.longtermIncompleteAssets) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.longtermCostOfWorkInProgress,
          InsuranceMapping.constructionInProgress,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.longtermInvestments) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.investmentInSubsidiaries,
          InsuranceMapping.investementInAssociates,
          InsuranceMapping.otherLongtermInvestements,
          InsuranceMapping.provisionForLongtermInvestments,
          InsuranceMapping.heldtomaturityInvestment,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.otherLongtermAssets) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.longtermPrepayments,
          InsuranceMapping.deferredIncomeTaxAssests,
          InsuranceMapping.longtermDeposit,
          InsuranceMapping.longtermEquimentMaterialAndSpare,
          InsuranceMapping.otherLongtermAssetsChild,
          InsuranceMapping.goodWill,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.currentLiabilities) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.shorttermLoans,
          InsuranceMapping.tradeAccountsPayable,
          InsuranceMapping.advancesFromCustomers,
          InsuranceMapping.taxesAndOtherPayableToStateBudget,
          InsuranceMapping.payableToEmployees,
          InsuranceMapping.accruedExpenses,
          InsuranceMapping.intercompanyPayables,
          InsuranceMapping.constructionContractInProgressPayables,
          InsuranceMapping.shorttermUnrealizedRevenue,
          InsuranceMapping.unearnedCommissionIncome,
          InsuranceMapping.otherPayables,
          InsuranceMapping.provisionForShorttermLiabilities,
          InsuranceMapping.bonusAndWelfareFunds,
          InsuranceMapping.priceStablizationFund,
          InsuranceMapping.governmentBondsPurchasedForResales,
          InsuranceMapping.insuranceReserve,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.tradeAccountsPayable) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          InsuranceMapping.payablesFromInsuranceContract,
          InsuranceMapping.payablesToSuppliers,
        ],
      };
    }

    if (
      [
        InsuranceMapping.payablesFromInsuranceContract,
        InsuranceMapping.payablesToSuppliers,
      ].includes(mappingValue)
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    if (mappingValue === InsuranceMapping.insuranceReserve) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          InsuranceMapping.unearnedPremiumReserve,
          InsuranceMapping.mathematicalReserve,
          InsuranceMapping.claimReserve,
          InsuranceMapping.catastropheReserve,
          InsuranceMapping.dividendReserve,
          InsuranceMapping.equalizationReserve,
        ],
      };
    }

    if (
      [
        InsuranceMapping.unearnedPremiumReserve,
        InsuranceMapping.mathematicalReserve,
        InsuranceMapping.claimReserve,
        InsuranceMapping.catastropheReserve,
        InsuranceMapping.dividendReserve,
        InsuranceMapping.equalizationReserve,
      ].includes(mappingValue)
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    if (mappingValue === InsuranceMapping.amountDueToCustomers) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.depositFormCommercialBanks,
          InsuranceMapping.depositFromCustomers,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.longtermLiabilites) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.longtermTradePayables,
          InsuranceMapping.longtermAdvancesFromCustomers,
          InsuranceMapping.longtermAccruedExpenses,
          InsuranceMapping.intracompanyPayablesForOperatingCapital,
          InsuranceMapping.longtermIntercompanyPayables,
          InsuranceMapping.otherLongtermPayables,
          InsuranceMapping.longtermLoans,
          InsuranceMapping.convertibleBonds,
          InsuranceMapping.preferredShares,
          InsuranceMapping.longtermDepositMortage,
          InsuranceMapping.deferredIncomeTaxesLiabilities,
          InsuranceMapping.provisionForSeveranceAllowances,
          InsuranceMapping.provisionForLongtermLiabilites,
          InsuranceMapping.deferredRevenue,
          InsuranceMapping.technologyscienceDevelopmentFund,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.reservesBefore) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.unearnedPremiumReserveBefore,
          InsuranceMapping.technicalReserveBefore,
          InsuranceMapping.claimReserveBefore,
          InsuranceMapping.catastropheReserveBefore,
          InsuranceMapping.dividendReseveBefore,
          InsuranceMapping.equalizatinReserveBefore,
        ],
      };
    }
    if (mappingValue === InsuranceMapping.capitalAndReserves) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.paidinCapital,
          InsuranceMapping.capitalSurplus,
          InsuranceMapping.ownersOtherCapital,
          InsuranceMapping.treasuryShares,
          InsuranceMapping.differencesUponAssetsRevaluation,
          InsuranceMapping.foreignExchangeDifferences,
          InsuranceMapping.investmentAndDevelopmentFunds,
          InsuranceMapping.financialReserveFunds,
          InsuranceMapping.statutoryReserve,
          InsuranceMapping.otherFunds,
          InsuranceMapping.undistributedEarnings,
          InsuranceMapping.enterpriseArragementFund,
          InsuranceMapping.minorityInterest,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.paidinCapital) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          InsuranceMapping.commonShares,
          InsuranceMapping.paidinCapitalPreferredShares,
        ],
      };
    }

    if (mappingValue === InsuranceMapping.undistributedEarnings) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          InsuranceMapping.beginningAccumulatedUndistritbutedEarning,
          InsuranceMapping.currentPeriodUndistributedEarnings,
        ],
      };
    }

    if (
      [
        InsuranceMapping.commonShares,
        InsuranceMapping.capitalAndReservesPreferredShares,
        InsuranceMapping.beginningAccumulatedUndistritbutedEarning,
        InsuranceMapping.currentPeriodUndistributedEarnings,
      ].includes(mappingValue)
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    if (mappingValue === InsuranceMapping.budgetSourcesAndOtherFunds) {
      return {
        ...defaultItem,
        children: [
          InsuranceMapping.bonusAndWelfareFundsBefore,
          InsuranceMapping.budgetSourcesAndOtherFundsChild,
          InsuranceMapping.fundsUsedForFixedAssetAcquisitions,
        ],
      };
    }

    return {
      ...defaultItem,
      level: LEVELS.CHILD,
    };
  }),
);

export const balanceSheetInsuranceChartTitles = [
  {
    key: 'currentAssets',
    color: '#e5efc1',
    i18nKey: 'financialStatement.BalanceSheetInsurance.currentAssetsLower',
  },
  {
    key: 'loansAndAdvancesToCustomersOne',
    color: '#a2d5ab',
    i18nKey:
      'financialStatement.BalanceSheetInsurance.loansAndAdvancesToCustomers',
  },
  {
    key: 'tangibleFixedAssets',
    color: '#3baea9',
    i18nKey: 'financialStatement.BalanceSheetInsurance.tangibleFixedAssets',
  },
  {
    key: 'intagibleFixedAssets',
    color: '#7e81bc',
    i18nKey: 'financialStatement.BalanceSheetInsurance.intagibleFixedAssets',
  },
  {
    key: 'otherAssets',
    color: '#358bbc',
    i18nKey: 'financialStatement.BalanceSheetInsurance.otherAssets',
  },
  {
    key: 'currentLiabilities',
    color: '#f8b195',
    i18nKey: 'financialStatement.BalanceSheetInsurance.currentLiabilities',
  },
  {
    key: 'longtermLiabilites',
    color: '#f27280',
    i18nKey: 'financialStatement.BalanceSheetInsurance.longtermLiabilites',
  },
  {
    key: 'otherLiabilites',
    color: '#f25b7e',
    i18nKey: 'financialStatement.BalanceSheetInsurance.otherLiabilites',
  },
  {
    key: 'shareholderEquity',
    color: '#b76880',
    i18nKey: 'financialStatement.BalanceSheetInsurance.shareholdersEquity',
  },
  {
    key: 'minorityInterestBefore',
    color: '#6c5c7c',
    i18nKey: 'financialStatement.BalanceSheetInsurance.minorityInterestBefore',
  },
];
